import React, { useState, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Label, getId } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withValidation, withError } from '@bingads-webui-react/validation';
import { ValidationGroup } from '@bingads-webui-react/primitive-validation';
import { LegacyI18nContext } from '@bingads-webui-react/legacy-i18n-context';
import { MAX_CONVERSIONS } from './options/max-conversions';
import { MAX_CONVERSIONS_VALUE } from './options/max-conversions-value';
import { inputStyles, labelStyles } from './styles/get-additional-details-styles';
import { TextFieldWithSuffix } from './text-field-with-suffix';

const ValidatedInput = withError(withValidation(TextFieldWithSuffix));

export const AdditionalDetails = (props) => {
  const {
    // Checkbox
    defaultChecked,
    checkboxLabel,
    // Input
    inputLabel,
    inputUnit,
    bidStrategy,
    marketingMetricsValue,
    onMarketingMetricChange,
    // Validation
    schema,
  } = props;

  const i18n = useContext(I18nContext);
  // ValidationGroup has dependency on legacyI18n
  const legacyI18n = useContext(LegacyI18nContext);

  const [checked, setChecked] = useState(defaultChecked);

  const onCheckboxChange = useCallback((e, val) => {
    setChecked(val);
    if (!val) {
      onMarketingMetricChange({ data: { cpa: null, roas: null } });
    }
  }, [onMarketingMetricChange]);

  const marketingMetricId = getId('marketing-metric-value');

  const onValidate = useCallback((result) => {
    onMarketingMetricChange(result);
  }, [onMarketingMetricChange]);

  return (
    <div className="additional-details">
      <Checkbox
        label={i18n.getString(checkboxLabel)}
        checked={checked}
        onChange={onCheckboxChange}
      />
      <ValidationGroup validationProps={{
        schema,
        onValidate,
        i18n: legacyI18n,
        data: marketingMetricsValue,
      }}
      >
        {
        checked ? (
          <>
            <Label
              htmlFor={marketingMetricId}
              id="label-marketing-metric"
              styles={labelStyles}
            >
              {i18n.getString(inputLabel)}
            </Label>
            {/* TODO: Don't know why this won't work */}
            {/* <ValidatedInput
              validationProps={{ field: bidStrategyConfig.marketingMetric }}
              id={marketingMetricId}
              styles={inputStyles}
              name={bidStrategyConfig.marketingMetric}
              unit={inputUnit}
            /> */}
            {
              bidStrategy === MAX_CONVERSIONS.type && (
                <ValidatedInput
                  validationProps={{ field: MAX_CONVERSIONS.marketingMetric }}
                  id={marketingMetricId}
                  styles={inputStyles}
                  name={MAX_CONVERSIONS.marketingMetric}
                  unit={inputUnit}
                />
              )
            }
            {
              bidStrategy === MAX_CONVERSIONS_VALUE.type && (
                <ValidatedInput
                  validationProps={{ field: MAX_CONVERSIONS_VALUE.marketingMetric }}
                  id={marketingMetricId}
                  styles={inputStyles}
                  name={MAX_CONVERSIONS_VALUE.marketingMetric}
                  unit="%"
                />
              )
            }
          </>
          ) : null
      }
      </ValidationGroup>
    </div >
  );
};


AdditionalDetails.propTypes = {
  defaultChecked: PropTypes.bool,
  checkboxLabel: PropTypes.string,
  inputLabel: PropTypes.string,
  inputUnit: PropTypes.string.isRequired,
  marketingMetricsValue: PropTypes.shape({
    cpa: PropTypes.number,
    roas: PropTypes.number,
  }).isRequired,
  bidStrategy: PropTypes.string.isRequired,
  data: PropTypes.shape({
    marketingMetric: PropTypes.number,
  }).isRequired,
  onMarketingMetricChange: PropTypes.func.isRequired,
  schema: PropTypes.shape({}).isRequired,
};

AdditionalDetails.defaultProps = {
  defaultChecked: false,
  checkboxLabel: _TL_(''),
  inputLabel: _TL_(''),
};
